import { startDate } from "Components/Preferences/components/preferences-email/components/new-report-form/NewReportForm.selector"
import { serialNumber } from "Selectors/DeviceUsageSelector"

const create = (api) => {
    const getBatteryLevelActivity = (deviceId, startDate, endDate, batteryId, siteId) => {
      let batteryString = batteryId == null ? '' : `batteryId=${batteryId}`
      return api.get(`/v2/device/${deviceId}/battery/level?${batteryString}&siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&timeUnit=hour`)
    }

    const getApplicationActivity = (serialNumber, siteId, startDate, endDate, timeUnit) => {
      return api.get(`/dashboard/v1/device/${serialNumber}/application-usage?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&timeUnit=${timeUnit}`)
    }

    const getApplicationBatteryInformation = (startDate, endDate, siteId, serialNumber, sort='applicationName', directionSort='1', searchTerm, language, pageNumber=1, pageSize=100) => {
      const query = searchTerm === undefined ? `&query=` : `&query=${searchTerm}`
      return api.get(`/dashboard/v1/device/${serialNumber}/battery-usage?siteId=${siteId}&startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`+ `${query}` +`&sort=${sort}&directionSort=${directionSort}&language=${language}`)
    }

    return {
      getApplicationActivity,
      getApplicationBatteryInformation,
      getBatteryLevelActivity
    }

  }

  export default {
    create
  }
